/*
  Drives the bundle buy box (snippets/bundle-buy-box.liquid):
  - Syncs the number of visible "Choose Scent" slots to the selected pack size
  - Validates every visible slot has a scent chosen before enabling Add to Cart
  - Toggles the Subscribe & Save selling-plan select on/off with purchase type
  - Submits via the AJAX cart API and hands off to the site's existing cart-open
    flow (same pattern as assets/custom-product-card-atc.js), so OCU's Slide
    Cart Drawer picks it up exactly like any other add-to-cart.
*/
(function () {
  function initBundleBuyBox(root) {
    const form = root.querySelector('[data-bundle-form]');
    if (!form || form.dataset.bundleInitialized) return;
    form.dataset.bundleInitialized = 'true';

    const variantIdInput = form.querySelector('[data-bundle-variant-id]');
    const packInputs = Array.from(form.querySelectorAll('[data-pack-size-input]'));
    const slots = Array.from(form.querySelectorAll('[data-scent-slot]'));
    const submitBtn = form.querySelector('[data-bundle-submit]');
    const message = form.querySelector('[data-bundle-validation-message]');
    const purchaseOnetime = form.querySelector('[data-purchase-onetime]');
    const purchaseSubscribe = form.querySelector('[data-purchase-subscribe]');
    const sellingPlanWrap = form.querySelector('[data-selling-plan-wrap]');
    const sellingPlanSelect = form.querySelector('[data-selling-plan-select]');

    function visibleSlotCount() {
      const checkedPack = packInputs.find((el) => el.checked);
      const count = checkedPack ? parseInt(checkedPack.dataset.scentCount, 10) : slots.length;
      return Number.isFinite(count) && count > 0 ? count : slots.length;
    }

    function syncSlotVisibility() {
      const count = visibleSlotCount();
      slots.forEach((slot) => {
        const index = parseInt(slot.dataset.scentSlot, 10);
        const visible = index <= count;
        slot.hidden = !visible;
        slot.querySelectorAll('[data-scent-input]').forEach((input) => {
          input.disabled = !visible;
        });
      });
    }

    function syncVariantId() {
      const checkedPack = packInputs.find((el) => el.checked);
      if (checkedPack && variantIdInput) {
        variantIdInput.value = checkedPack.value;
      }
    }

    function validate() {
      const count = visibleSlotCount();
      for (let i = 1; i <= count; i++) {
        const slot = slots.find((s) => parseInt(s.dataset.scentSlot, 10) === i);
        if (!slot) continue;
        const hasChoice = slot.querySelectorAll('[data-scent-input]:checked').length > 0;
        if (!hasChoice) {
          submitBtn.disabled = true;
          if (message) message.textContent = `Choose a scent for slot ${i} of ${count} to continue.`;
          return false;
        }
      }
      submitBtn.disabled = false;
      if (message) message.textContent = '';
      return true;
    }

    packInputs.forEach((input) => {
      input.addEventListener('change', () => {
        syncVariantId();
        syncSlotVisibility();
        validate();
      });
    });

    slots.forEach((slot) => {
      slot.addEventListener('change', validate);
    });

    if (purchaseOnetime && purchaseSubscribe && sellingPlanWrap && sellingPlanSelect) {
      function syncPurchaseType() {
        const subscribing = purchaseSubscribe.checked;
        sellingPlanWrap.hidden = !subscribing;
        sellingPlanSelect.disabled = !subscribing;
      }
      purchaseOnetime.addEventListener('change', syncPurchaseType);
      purchaseSubscribe.addEventListener('change', syncPurchaseType);
      syncPurchaseType();
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!validate()) return;

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin',
      })
        .then((res) => {
          if (!res.ok) {
            return res.json().then((body) => {
              throw new Error(body.description || 'Could not add this bundle to your cart.');
            });
          }
          return res.json();
        })
        .then(() => {
          try {
            document.dispatchEvent(new CustomEvent('cart:build'));
          } catch (e) {
            /* no-op */
          }
          const drawerTrigger = document.querySelector('.js-drawer-open-cart');
          if (drawerTrigger) {
            drawerTrigger.dispatchEvent(new Event('click', { bubbles: true }));
          }
        })
        .catch((err) => {
          if (message) message.textContent = err.message;
        })
        .finally(() => {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          validate();
        });
    });

    syncSlotVisibility();
    validate();
  }

  document.querySelectorAll('[data-bundle-buy-box]').forEach(initBundleBuyBox);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-bundle-buy-box]').forEach(initBundleBuyBox);
  });
})();
